module.exports = { "default": require("core-js/library/fn/number/is-nan"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ../~/babel-runtime/core-js/number/is-nan.js
// module id = 515
// module chunks = 0